let phoneCountries = {
  af: {
    key: 'af',
    name: 'Afghanistan (‫افغانستان‬‎)',
    iso2: 'af',
    dialCode: '93',
    priority: 1,
    areaCodes: null,
  },
  al: {
    key: 'al',
    name: 'Albania (Shqipëri)',
    iso2: 'al',
    dialCode: '355',
    priority: 1,
    areaCodes: null,
  },
  dz: {
    key: 'dz',
    name: 'Algeria (‫الجزائر‬‎)',
    iso2: 'dz',
    dialCode: '213',
    priority: 1,
    areaCodes: null,
  },
  as: {
    key: 'as',
    name: 'American Samoa',
    iso2: 'as',
    dialCode: '1',
    priority: 5,
    areaCodes: ['684'],
  },
  ad: {
    key: 'ad',
    name: 'Andorra',
    iso2: 'ad',
    dialCode: '376',
    priority: 1,
    areaCodes: null,
  },
  ao: {
    key: 'ao',
    name: 'Angola',
    iso2: 'ao',
    dialCode: '244',
    priority: 1,
    areaCodes: null,
  },
  ai: {
    key: 'ai',
    name: 'Anguilla',
    iso2: 'ai',
    dialCode: '1',
    priority: 6,
    areaCodes: ['264'],
  },
  ag: {
    key: 'ag',
    name: 'Antigua and Barbuda',
    iso2: 'ag',
    dialCode: '1',
    priority: 7,
    areaCodes: ['268'],
  },
  ar: {
    key: 'ar',
    name: 'Argentina',
    iso2: 'ar',
    dialCode: '54',
    priority: 1,
    areaCodes: null,
  },
  am: {
    key: 'am',
    name: 'Armenia (Հայաստան)',
    iso2: 'am',
    dialCode: '374',
    priority: 1,
    areaCodes: null,
  },
  aw: {
    key: 'aw',
    name: 'Aruba',
    iso2: 'aw',
    dialCode: '297',
    priority: 1,
    areaCodes: null,
  },
  ac: {
    key: 'ac',
    name: 'Ascension Island',
    iso2: 'ac',
    dialCode: '247',
    priority: 1,
    areaCodes: null,
  },
  au: {
    key: 'au',
    name: 'Australia',
    iso2: 'au',
    dialCode: '61',
    priority: 1,
    areaCodes: null,
  },
  at: {
    key: 'at',
    name: 'Austria (Österreich)',
    iso2: 'at',
    dialCode: '43',
    priority: 1,
    areaCodes: null,
  },
  az: {
    key: 'az',
    name: 'Azerbaijan (Azərbaycan)',
    iso2: 'az',
    dialCode: '994',
    priority: 1,
    areaCodes: null,
  },
  bs: {
    key: 'bs',
    name: 'Bahamas',
    iso2: 'bs',
    dialCode: '1',
    priority: 8,
    areaCodes: ['242'],
  },
  bh: {
    key: 'bh',
    name: 'Bahrain (‫البحرين‬‎)',
    iso2: 'bh',
    dialCode: '973',
    priority: 1,
    areaCodes: null,
  },
  bd: {
    key: 'bd',
    name: 'Bangladesh (বাংলাদেশ)',
    iso2: 'bd',
    dialCode: '880',
    priority: 1,
    areaCodes: null,
  },
  bb: {
    key: 'bb',
    name: 'Barbados',
    iso2: 'bb',
    dialCode: '1',
    priority: 9,
    areaCodes: ['246'],
  },
  by: {
    key: 'by',
    name: 'Belarus (Беларусь)',
    iso2: 'by',
    dialCode: '375',
    priority: 1,
    areaCodes: null,
  },
  be: {
    key: 'be',
    name: 'Belgium (België)',
    iso2: 'be',
    dialCode: '32',
    priority: 1,
    areaCodes: null,
  },
  bz: {
    key: 'bz',
    name: 'Belize',
    iso2: 'bz',
    dialCode: '501',
    priority: 1,
    areaCodes: null,
  },
  bj: {
    key: 'bj',
    name: 'Benin (Bénin)',
    iso2: 'bj',
    dialCode: '229',
    priority: 1,
    areaCodes: null,
  },
  bm: {
    key: 'bm',
    name: 'Bermuda',
    iso2: 'bm',
    dialCode: '1',
    priority: 10,
    areaCodes: ['441'],
  },
  bt: {
    key: 'bt',
    name: 'Bhutan (འབྲུག)',
    iso2: 'bt',
    dialCode: '975',
    priority: 1,
    areaCodes: null,
  },
  bo: {
    key: 'bo',
    name: 'Bolivia',
    iso2: 'bo',
    dialCode: '591',
    priority: 1,
    areaCodes: null,
  },
  ba: {
    key: 'ba',
    name: 'Bosnia and Herzegovina (Босна и Херцеговина)',
    iso2: 'ba',
    dialCode: '387',
    priority: 1,
    areaCodes: null,
  },
  bw: {
    key: 'bw',
    name: 'Botswana',
    iso2: 'bw',
    dialCode: '267',
    priority: 1,
    areaCodes: null,
  },
  br: {
    key: 'br',
    name: 'Brazil (Brasil)',
    iso2: 'br',
    dialCode: '55',
    priority: 1,
    areaCodes: null,
  },
  io: {
    key: 'io',
    name: 'British Indian Ocean Territory',
    iso2: 'io',
    dialCode: '246',
    priority: 1,
    areaCodes: null,
  },
  vg: {
    key: 'vg',
    name: 'British Virgin Islands',
    iso2: 'vg',
    dialCode: '1',
    priority: 11,
    areaCodes: ['284'],
  },
  bn: {
    key: 'bn',
    name: 'Brunei',
    iso2: 'bn',
    dialCode: '673',
    priority: 1,
    areaCodes: null,
  },
  bg: {
    key: 'bg',
    name: 'Bulgaria (България)',
    iso2: 'bg',
    dialCode: '359',
    priority: 1,
    areaCodes: null,
  },
  bf: {
    key: 'bf',
    name: 'Burkina Faso',
    iso2: 'bf',
    dialCode: '226',
    priority: 1,
    areaCodes: null,
  },
  bi: {
    key: 'bi',
    name: 'Burundi (Uburundi)',
    iso2: 'bi',
    dialCode: '257',
    priority: 1,
    areaCodes: null,
  },
  kh: {
    key: 'kh',
    name: 'Cambodia (កម្ពុជា)',
    iso2: 'kh',
    dialCode: '855',
    priority: 1,
    areaCodes: null,
  },
  cm: {
    key: 'cm',
    name: 'Cameroon (Cameroun)',
    iso2: 'cm',
    dialCode: '237',
    priority: 1,
    areaCodes: null,
  },
  ca: {
    key: 'ca',
    name: 'Canada',
    iso2: 'ca',
    dialCode: '1',
    priority: 1,
    areaCodes: [
      '204',
      '226',
      '236',
      '249',
      '250',
      '289',
      '306',
      '343',
      '365',
      '387',
      '403',
      '416',
      '418',
      '431',
      '437',
      '438',
      '450',
      '506',
      '514',
      '519',
      '548',
      '579',
      '581',
      '587',
      '604',
      '613',
      '639',
      '647',
      '672',
      '705',
      '709',
      '742',
      '778',
      '780',
      '782',
      '807',
      '819',
      '825',
      '867',
      '873',
      '902',
      '905',
    ],
  },
  cv: {
    key: 'cv',
    name: 'Cape Verde (Kabu Verdi)',
    iso2: 'cv',
    dialCode: '238',
    priority: 1,
    areaCodes: null,
  },
  bq: {
    key: 'bq',
    name: 'Caribbean Netherlands',
    iso2: 'bq',
    dialCode: '599',
    priority: 1,
    areaCodes: ['3', '4', '7'],
  },
  ky: {
    key: 'ky',
    name: 'Cayman Islands',
    iso2: 'ky',
    dialCode: '1',
    priority: 12,
    areaCodes: ['345'],
  },
  cf: {
    key: 'cf',
    name: 'Central African Republic (République centrafricaine)',
    iso2: 'cf',
    dialCode: '236',
    priority: 1,
    areaCodes: null,
  },
  td: {
    key: 'td',
    name: 'Chad (Tchad)',
    iso2: 'td',
    dialCode: '235',
    priority: 1,
    areaCodes: null,
  },
  cl: {
    key: 'cl',
    name: 'Chile',
    iso2: 'cl',
    dialCode: '56',
    priority: 1,
    areaCodes: null,
  },
  cn: {
    key: 'cn',
    name: 'China (中国)',
    iso2: 'cn',
    dialCode: '86',
    priority: 1,
    areaCodes: null,
  },
  cx: {
    key: 'cx',
    name: 'Christmas Island',
    iso2: 'cx',
    dialCode: '61',
    priority: 2,
    areaCodes: ['89164'],
  },
  cc: {
    key: 'cc',
    name: 'Cocos (Keeling) Islands',
    iso2: 'cc',
    dialCode: '61',
    priority: 1,
    areaCodes: ['89162'],
  },
  co: {
    key: 'co',
    name: 'Colombia',
    iso2: 'co',
    dialCode: '57',
    priority: 1,
    areaCodes: null,
  },
  km: {
    key: 'km',
    name: 'Comoros (‫جزر القمر‬‎)',
    iso2: 'km',
    dialCode: '269',
    priority: 1,
    areaCodes: null,
  },
  cd: {
    key: 'cd',
    name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
    iso2: 'cd',
    dialCode: '243',
    priority: 1,
    areaCodes: null,
  },
  cg: {
    key: 'cg',
    name: 'Congo (Republic) (Congo-Brazzaville)',
    iso2: 'cg',
    dialCode: '242',
    priority: 1,
    areaCodes: null,
  },
  ck: {
    key: 'ck',
    name: 'Cook Islands',
    iso2: 'ck',
    dialCode: '682',
    priority: 1,
    areaCodes: null,
  },
  cr: {
    key: 'cr',
    name: 'Costa Rica',
    iso2: 'cr',
    dialCode: '506',
    priority: 1,
    areaCodes: null,
  },
  ci: {
    key: 'ci',
    name: 'Côte d’Ivoire',
    iso2: 'ci',
    dialCode: '225',
    priority: 1,
    areaCodes: null,
  },
  hr: {
    key: 'hr',
    name: 'Croatia (Hrvatska)',
    iso2: 'hr',
    dialCode: '385',
    priority: 1,
    areaCodes: null,
  },
  cu: {
    key: 'cu',
    name: 'Cuba',
    iso2: 'cu',
    dialCode: '53',
    priority: 1,
    areaCodes: null,
  },
  cw: {
    key: 'cw',
    name: 'Curaçao',
    iso2: 'cw',
    dialCode: '599',
    priority: 1,
    areaCodes: null,
  },
  cy: {
    key: 'cy',
    name: 'Cyprus (Κύπρος)',
    iso2: 'cy',
    dialCode: '357',
    priority: 1,
    areaCodes: null,
  },
  cz: {
    key: 'cz',
    name: 'Czech Republic (Česká republika)',
    iso2: 'cz',
    dialCode: '420',
    priority: 1,
    areaCodes: null,
  },
  dk: {
    key: 'dk',
    name: 'Denmark (Danmark)',
    iso2: 'dk',
    dialCode: '45',
    priority: 1,
    areaCodes: null,
  },
  dj: {
    key: 'dj',
    name: 'Djibouti',
    iso2: 'dj',
    dialCode: '253',
    priority: 1,
    areaCodes: null,
  },
  dm: {
    key: 'dm',
    name: 'Dominica',
    iso2: 'dm',
    dialCode: '1',
    priority: 13,
    areaCodes: ['767'],
  },
  do: {
    key: 'do',
    name: 'Dominican Republic (República Dominicana)',
    iso2: 'do',
    dialCode: '1',
    priority: 2,
    areaCodes: ['809', '829', '849'],
  },
  ec: {
    key: 'ec',
    name: 'Ecuador',
    iso2: 'ec',
    dialCode: '593',
    priority: 1,
    areaCodes: null,
  },
  eg: {
    key: 'eg',
    name: 'Egypt (‫مصر‬‎)',
    iso2: 'eg',
    dialCode: '20',
    priority: 1,
    areaCodes: null,
  },
  sv: {
    key: 'sv',
    name: 'El Salvador',
    iso2: 'sv',
    dialCode: '503',
    priority: 1,
    areaCodes: null,
  },
  gq: {
    key: 'gq',
    name: 'Equatorial Guinea (Guinea Ecuatorial)',
    iso2: 'gq',
    dialCode: '240',
    priority: 1,
    areaCodes: null,
  },
  er: {
    key: 'er',
    name: 'Eritrea',
    iso2: 'er',
    dialCode: '291',
    priority: 1,
    areaCodes: null,
  },
  ee: {
    key: 'ee',
    name: 'Estonia (Eesti)',
    iso2: 'ee',
    dialCode: '372',
    priority: 1,
    areaCodes: null,
  },
  sz: {
    key: 'sz',
    name: 'Eswatini',
    iso2: 'sz',
    dialCode: '268',
    priority: 1,
    areaCodes: null,
  },
  et: {
    key: 'et',
    name: 'Ethiopia',
    iso2: 'et',
    dialCode: '251',
    priority: 1,
    areaCodes: null,
  },
  fk: {
    key: 'fk',
    name: 'Falkland Islands (Islas Malvinas)',
    iso2: 'fk',
    dialCode: '500',
    priority: 1,
    areaCodes: null,
  },
  fo: {
    key: 'fo',
    name: 'Faroe Islands (Føroyar)',
    iso2: 'fo',
    dialCode: '298',
    priority: 1,
    areaCodes: null,
  },
  fj: {
    key: 'fj',
    name: 'Fiji',
    iso2: 'fj',
    dialCode: '679',
    priority: 1,
    areaCodes: null,
  },
  fi: {
    key: 'fi',
    name: 'Finland (Suomi)',
    iso2: 'fi',
    dialCode: '358',
    priority: 1,
    areaCodes: null,
  },
  fr: {
    key: 'fr',
    name: 'France',
    iso2: 'fr',
    dialCode: '33',
    priority: 1,
    areaCodes: null,
  },
  gf: {
    key: 'gf',
    name: 'French Guiana (Guyane française)',
    iso2: 'gf',
    dialCode: '594',
    priority: 1,
    areaCodes: null,
  },
  pf: {
    key: 'pf',
    name: 'French Polynesia (Polynésie française)',
    iso2: 'pf',
    dialCode: '689',
    priority: 1,
    areaCodes: null,
  },
  ga: {
    key: 'ga',
    name: 'Gabon',
    iso2: 'ga',
    dialCode: '241',
    priority: 1,
    areaCodes: null,
  },
  gm: {
    key: 'gm',
    name: 'Gambia',
    iso2: 'gm',
    dialCode: '220',
    priority: 1,
    areaCodes: null,
  },
  ge: {
    key: 'ge',
    name: 'Georgia (საქართველო)',
    iso2: 'ge',
    dialCode: '995',
    priority: 1,
    areaCodes: null,
  },
  de: {
    key: 'de',
    name: 'Germany (Deutschland)',
    iso2: 'de',
    dialCode: '49',
    priority: 1,
    areaCodes: null,
  },
  gh: {
    key: 'gh',
    name: 'Ghana (Gaana)',
    iso2: 'gh',
    dialCode: '233',
    priority: 1,
    areaCodes: null,
  },
  gi: {
    key: 'gi',
    name: 'Gibraltar',
    iso2: 'gi',
    dialCode: '350',
    priority: 1,
    areaCodes: null,
  },
  gr: {
    key: 'gr',
    name: 'Greece (Ελλάδα)',
    iso2: 'gr',
    dialCode: '30',
    priority: 1,
    areaCodes: null,
  },
  gl: {
    key: 'gl',
    name: 'Greenland (Kalaallit Nunaat)',
    iso2: 'gl',
    dialCode: '299',
    priority: 1,
    areaCodes: null,
  },
  gd: {
    key: 'gd',
    name: 'Grenada',
    iso2: 'gd',
    dialCode: '1',
    priority: 14,
    areaCodes: ['473'],
  },
  gp: {
    key: 'gp',
    name: 'Guadeloupe',
    iso2: 'gp',
    dialCode: '590',
    priority: 1,
    areaCodes: null,
  },
  gu: {
    key: 'gu',
    name: 'Guam',
    iso2: 'gu',
    dialCode: '1',
    priority: 15,
    areaCodes: ['671'],
  },
  gt: {
    key: 'gt',
    name: 'Guatemala',
    iso2: 'gt',
    dialCode: '502',
    priority: 1,
    areaCodes: null,
  },
  gg: {
    key: 'gg',
    name: 'Guernsey',
    iso2: 'gg',
    dialCode: '44',
    priority: 1,
    areaCodes: ['1481', '7781', '7839', '7911'],
  },
  gn: {
    key: 'gn',
    name: 'Guinea (Guinée)',
    iso2: 'gn',
    dialCode: '224',
    priority: 1,
    areaCodes: null,
  },
  gw: {
    key: 'gw',
    name: 'Guinea-Bissau (Guiné Bissau)',
    iso2: 'gw',
    dialCode: '245',
    priority: 1,
    areaCodes: null,
  },
  gy: {
    key: 'gy',
    name: 'Guyana',
    iso2: 'gy',
    dialCode: '592',
    priority: 1,
    areaCodes: null,
  },
  ht: {
    key: 'ht',
    name: 'Haiti',
    iso2: 'ht',
    dialCode: '509',
    priority: 1,
    areaCodes: null,
  },
  hn: {
    key: 'hn',
    name: 'Honduras',
    iso2: 'hn',
    dialCode: '504',
    priority: 1,
    areaCodes: null,
  },
  hk: {
    key: 'hk',
    name: 'Hong Kong (香港)',
    iso2: 'hk',
    dialCode: '852',
    priority: 1,
    areaCodes: null,
  },
  hu: {
    key: 'hu',
    name: 'Hungary (Magyarország)',
    iso2: 'hu',
    dialCode: '36',
    priority: 1,
    areaCodes: null,
  },
  is: {
    key: 'is',
    name: 'Iceland (Ísland)',
    iso2: 'is',
    dialCode: '354',
    priority: 1,
    areaCodes: null,
  },
  in: {
    key: 'in',
    name: 'India (भारत)',
    iso2: 'in',
    dialCode: '91',
    priority: 1,
    areaCodes: null,
  },
  id: {
    key: 'id',
    name: 'Indonesia',
    iso2: 'id',
    dialCode: '62',
    priority: 1,
    areaCodes: null,
  },
  ir: {
    key: 'ir',
    name: 'Iran (‫ایران‬‎)',
    iso2: 'ir',
    dialCode: '98',
    priority: 1,
    areaCodes: null,
  },
  iq: {
    key: 'iq',
    name: 'Iraq (‫العراق‬‎)',
    iso2: 'iq',
    dialCode: '964',
    priority: 1,
    areaCodes: null,
  },
  ie: {
    key: 'ie',
    name: 'Ireland',
    iso2: 'ie',
    dialCode: '353',
    priority: 1,
    areaCodes: null,
  },
  im: {
    key: 'im',
    name: 'Isle of Man',
    iso2: 'im',
    dialCode: '44',
    priority: 2,
    areaCodes: ['1624', '74576', '7524', '7924', '7624'],
  },
  il: {
    key: 'il',
    name: 'Israel (‫ישראל‬‎)',
    iso2: 'il',
    dialCode: '972',
    priority: 1,
    areaCodes: null,
  },
  it: {
    key: 'it',
    name: 'Italy (Italia)',
    iso2: 'it',
    dialCode: '39',
    priority: 1,
    areaCodes: null,
  },
  jm: {
    key: 'jm',
    name: 'Jamaica',
    iso2: 'jm',
    dialCode: '1',
    priority: 4,
    areaCodes: ['876', '658'],
  },
  jp: {
    key: 'jp',
    name: 'Japan (日本)',
    iso2: 'jp',
    dialCode: '81',
    priority: 1,
    areaCodes: null,
  },
  je: {
    key: 'je',
    name: 'Jersey',
    iso2: 'je',
    dialCode: '44',
    priority: 3,
    areaCodes: ['1534', '7509', '7700', '7797', '7829', '7937'],
  },
  jo: {
    key: 'jo',
    name: 'Jordan (‫الأردن‬‎)',
    iso2: 'jo',
    dialCode: '962',
    priority: 1,
    areaCodes: null,
  },
  kz: {
    key: 'kz',
    name: 'Kazakhstan (Казахстан)',
    iso2: 'kz',
    dialCode: '7',
    priority: 1,
    areaCodes: ['33', '7'],
  },
  ke: {
    key: 'ke',
    name: 'Kenya',
    iso2: 'ke',
    dialCode: '254',
    priority: 1,
    areaCodes: null,
  },
  ki: {
    key: 'ki',
    name: 'Kiribati',
    iso2: 'ki',
    dialCode: '686',
    priority: 1,
    areaCodes: null,
  },
  xk: {
    key: 'xk',
    name: 'Kosovo',
    iso2: 'xk',
    dialCode: '383',
    priority: 1,
    areaCodes: null,
  },
  kw: {
    key: 'kw',
    name: 'Kuwait (‫الكويت‬‎)',
    iso2: 'kw',
    dialCode: '965',
    priority: 1,
    areaCodes: null,
  },
  kg: {
    key: 'kg',
    name: 'Kyrgyzstan (Кыргызстан)',
    iso2: 'kg',
    dialCode: '996',
    priority: 1,
    areaCodes: null,
  },
  la: {
    key: 'la',
    name: 'Laos (ລາວ)',
    iso2: 'la',
    dialCode: '856',
    priority: 1,
    areaCodes: null,
  },
  lv: {
    key: 'lv',
    name: 'Latvia (Latvija)',
    iso2: 'lv',
    dialCode: '371',
    priority: 1,
    areaCodes: null,
  },
  lb: {
    key: 'lb',
    name: 'Lebanon (‫لبنان‬‎)',
    iso2: 'lb',
    dialCode: '961',
    priority: 1,
    areaCodes: null,
  },
  ls: {
    key: 'ls',
    name: 'Lesotho',
    iso2: 'ls',
    dialCode: '266',
    priority: 1,
    areaCodes: null,
  },
  lr: {
    key: 'lr',
    name: 'Liberia',
    iso2: 'lr',
    dialCode: '231',
    priority: 1,
    areaCodes: null,
  },
  ly: {
    key: 'ly',
    name: 'Libya (‫ليبيا‬‎)',
    iso2: 'ly',
    dialCode: '218',
    priority: 1,
    areaCodes: null,
  },
  li: {
    key: 'li',
    name: 'Liechtenstein',
    iso2: 'li',
    dialCode: '423',
    priority: 1,
    areaCodes: null,
  },
  lt: {
    key: 'lt',
    name: 'Lithuania (Lietuva)',
    iso2: 'lt',
    dialCode: '370',
    priority: 1,
    areaCodes: null,
  },
  lu: {
    key: 'lu',
    name: 'Luxembourg',
    iso2: 'lu',
    dialCode: '352',
    priority: 1,
    areaCodes: null,
  },
  mo: {
    key: 'mo',
    name: 'Macau (澳門)',
    iso2: 'mo',
    dialCode: '853',
    priority: 1,
    areaCodes: null,
  },
  mk: {
    key: 'mk',
    name: 'Macedonia (FYROM) (Македонија)',
    iso2: 'mk',
    dialCode: '389',
    priority: 1,
    areaCodes: null,
  },
  mg: {
    key: 'mg',
    name: 'Madagascar (Madagasikara)',
    iso2: 'mg',
    dialCode: '261',
    priority: 1,
    areaCodes: null,
  },
  mw: {
    key: 'mw',
    name: 'Malawi',
    iso2: 'mw',
    dialCode: '265',
    priority: 1,
    areaCodes: null,
  },
  my: {
    key: 'my',
    name: 'Malaysia',
    iso2: 'my',
    dialCode: '60',
    priority: 1,
    areaCodes: null,
  },
  mv: {
    key: 'mv',
    name: 'Maldives',
    iso2: 'mv',
    dialCode: '960',
    priority: 1,
    areaCodes: null,
  },
  ml: {
    key: 'ml',
    name: 'Mali',
    iso2: 'ml',
    dialCode: '223',
    priority: 1,
    areaCodes: null,
  },
  mt: {
    key: 'mt',
    name: 'Malta',
    iso2: 'mt',
    dialCode: '356',
    priority: 1,
    areaCodes: null,
  },
  mh: {
    key: 'mh',
    name: 'Marshall Islands',
    iso2: 'mh',
    dialCode: '692',
    priority: 1,
    areaCodes: null,
  },
  mq: {
    key: 'mq',
    name: 'Martinique',
    iso2: 'mq',
    dialCode: '596',
    priority: 1,
    areaCodes: null,
  },
  mr: {
    key: 'mr',
    name: 'Mauritania (‫موريتانيا‬‎)',
    iso2: 'mr',
    dialCode: '222',
    priority: 1,
    areaCodes: null,
  },
  mu: {
    key: 'mu',
    name: 'Mauritius (Moris)',
    iso2: 'mu',
    dialCode: '230',
    priority: 1,
    areaCodes: null,
  },
  yt: {
    key: 'yt',
    name: 'Mayotte',
    iso2: 'yt',
    dialCode: '262',
    priority: 1,
    areaCodes: ['269', '639'],
  },
  mx: {
    key: 'mx',
    name: 'Mexico (México)',
    iso2: 'mx',
    dialCode: '52',
    priority: 0,
    areaCodes: null,
  },
  fm: {
    key: 'fm',
    name: 'Micronesia',
    iso2: 'fm',
    dialCode: '691',
    priority: 1,
    areaCodes: null,
  },
  md: {
    key: 'md',
    name: 'Moldova (Republica Moldova)',
    iso2: 'md',
    dialCode: '373',
    priority: 1,
    areaCodes: null,
  },
  mc: {
    key: 'mc',
    name: 'Monaco',
    iso2: 'mc',
    dialCode: '377',
    priority: 1,
    areaCodes: null,
  },
  mn: {
    key: 'mn',
    name: 'Mongolia (Монгол)',
    iso2: 'mn',
    dialCode: '976',
    priority: 1,
    areaCodes: null,
  },
  me: {
    key: 'me',
    name: 'Montenegro (Crna Gora)',
    iso2: 'me',
    dialCode: '382',
    priority: 1,
    areaCodes: null,
  },
  ms: {
    key: 'ms',
    name: 'Montserrat',
    iso2: 'ms',
    dialCode: '1',
    priority: 16,
    areaCodes: ['664'],
  },
  ma: {
    key: 'ma',
    name: 'Morocco (‫المغرب‬‎)',
    iso2: 'ma',
    dialCode: '212',
    priority: 1,
    areaCodes: null,
  },
  mz: {
    key: 'mz',
    name: 'Mozambique (Moçambique)',
    iso2: 'mz',
    dialCode: '258',
    priority: 1,
    areaCodes: null,
  },
  mm: {
    key: 'mm',
    name: 'Myanmar (Burma) (မြန်မာ)',
    iso2: 'mm',
    dialCode: '95',
    priority: 1,
    areaCodes: null,
  },
  na: {
    key: 'na',
    name: 'Namibia (Namibië)',
    iso2: 'na',
    dialCode: '264',
    priority: 1,
    areaCodes: null,
  },
  nr: {
    key: 'nr',
    name: 'Nauru',
    iso2: 'nr',
    dialCode: '674',
    priority: 1,
    areaCodes: null,
  },
  np: {
    key: 'np',
    name: 'Nepal (नेपाल)',
    iso2: 'np',
    dialCode: '977',
    priority: 1,
    areaCodes: null,
  },
  nl: {
    key: 'nl',
    name: 'Netherlands (Nederland)',
    iso2: 'nl',
    dialCode: '31',
    priority: 1,
    areaCodes: null,
  },
  nc: {
    key: 'nc',
    name: 'New Caledonia (Nouvelle-Calédonie)',
    iso2: 'nc',
    dialCode: '687',
    priority: 1,
    areaCodes: null,
  },
  nz: {
    key: 'nz',
    name: 'New Zealand',
    iso2: 'nz',
    dialCode: '64',
    priority: 1,
    areaCodes: null,
  },
  ni: {
    key: 'ni',
    name: 'Nicaragua',
    iso2: 'ni',
    dialCode: '505',
    priority: 1,
    areaCodes: null,
  },
  ne: {
    key: 'ne',
    name: 'Niger (Nijar)',
    iso2: 'ne',
    dialCode: '227',
    priority: 1,
    areaCodes: null,
  },
  ng: {
    key: 'ng',
    name: 'Nigeria',
    iso2: 'ng',
    dialCode: '234',
    priority: 1,
    areaCodes: null,
  },
  nu: {
    key: 'nu',
    name: 'Niue',
    iso2: 'nu',
    dialCode: '683',
    priority: 1,
    areaCodes: null,
  },
  nf: {
    key: 'nf',
    name: 'Norfolk Island',
    iso2: 'nf',
    dialCode: '672',
    priority: 1,
    areaCodes: null,
  },
  kp: {
    key: 'kp',
    name: 'North Korea (조선 민주주의 인민 공화국)',
    iso2: 'kp',
    dialCode: '850',
    priority: 1,
    areaCodes: null,
  },
  mp: {
    key: 'mp',
    name: 'Northern Mariana Islands',
    iso2: 'mp',
    dialCode: '1',
    priority: 17,
    areaCodes: ['670'],
  },
  no: {
    key: 'no',
    name: 'Norway (Norge)',
    iso2: 'no',
    dialCode: '47',
    priority: 1,
    areaCodes: null,
  },
  om: {
    key: 'om',
    name: 'Oman (‫عُمان‬‎)',
    iso2: 'om',
    dialCode: '968',
    priority: 1,
    areaCodes: null,
  },
  pk: {
    key: 'pk',
    name: 'Pakistan (‫پاکستان‬‎)',
    iso2: 'pk',
    dialCode: '92',
    priority: 1,
    areaCodes: null,
  },
  pw: {
    key: 'pw',
    name: 'Palau',
    iso2: 'pw',
    dialCode: '680',
    priority: 1,
    areaCodes: null,
  },
  ps: {
    key: 'ps',
    name: 'Palestine (‫فلسطين‬‎)',
    iso2: 'ps',
    dialCode: '970',
    priority: 1,
    areaCodes: null,
  },
  pa: {
    key: 'pa',
    name: 'Panama (Panamá)',
    iso2: 'pa',
    dialCode: '507',
    priority: 1,
    areaCodes: null,
  },
  pg: {
    key: 'pg',
    name: 'Papua New Guinea',
    iso2: 'pg',
    dialCode: '675',
    priority: 1,
    areaCodes: null,
  },
  py: {
    key: 'py',
    name: 'Paraguay',
    iso2: 'py',
    dialCode: '595',
    priority: 1,
    areaCodes: null,
  },
  pe: {
    key: 'pe',
    name: 'Peru (Perú)',
    iso2: 'pe',
    dialCode: '51',
    priority: 1,
    areaCodes: null,
  },
  ph: {
    key: 'ph',
    name: 'Philippines',
    iso2: 'ph',
    dialCode: '63',
    priority: 1,
    areaCodes: null,
  },
  pl: {
    key: 'pl',
    name: 'Poland (Polska)',
    iso2: 'pl',
    dialCode: '48',
    priority: 1,
    areaCodes: null,
  },
  pt: {
    key: 'pt',
    name: 'Portugal',
    iso2: 'pt',
    dialCode: '351',
    priority: 1,
    areaCodes: null,
  },
  pr: {
    key: 'pr',
    name: 'Puerto Rico',
    iso2: 'pr',
    dialCode: '1',
    priority: 3,
    areaCodes: ['787', '939'],
  },
  qa: {
    key: 'qa',
    name: 'Qatar (‫قطر‬‎)',
    iso2: 'qa',
    dialCode: '974',
    priority: 1,
    areaCodes: null,
  },
  re: {
    key: 're',
    name: 'Réunion (La Réunion)',
    iso2: 're',
    dialCode: '262',
    priority: 1,
    areaCodes: null,
  },
  ro: {
    key: 'ro',
    name: 'Romania (România)',
    iso2: 'ro',
    dialCode: '40',
    priority: 1,
    areaCodes: null,
  },
  ru: {
    key: 'ru',
    name: 'Russia (Россия)',
    iso2: 'ru',
    dialCode: '7',
    priority: 1,
    areaCodes: null,
  },
  rw: {
    key: 'rw',
    name: 'Rwanda',
    iso2: 'rw',
    dialCode: '250',
    priority: 1,
    areaCodes: null,
  },
  bl: {
    key: 'bl',
    name: 'Saint Barthélemy',
    iso2: 'bl',
    dialCode: '590',
    priority: 1,
    areaCodes: null,
  },
  sh: {
    key: 'sh',
    name: 'Saint Helena',
    iso2: 'sh',
    dialCode: '290',
    priority: 1,
    areaCodes: null,
  },
  kn: {
    key: 'kn',
    name: 'Saint Kitts and Nevis',
    iso2: 'kn',
    dialCode: '1',
    priority: 18,
    areaCodes: ['869'],
  },
  lc: {
    key: 'lc',
    name: 'Saint Lucia',
    iso2: 'lc',
    dialCode: '1',
    priority: 19,
    areaCodes: ['758'],
  },
  mf: {
    key: 'mf',
    name: 'Saint Martin (Saint-Martin (partie française))',
    iso2: 'mf',
    dialCode: '590',
    priority: 2,
    areaCodes: null,
  },
  pm: {
    key: 'pm',
    name: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    iso2: 'pm',
    dialCode: '508',
    priority: 1,
    areaCodes: null,
  },
  vc: {
    key: 'vc',
    name: 'Saint Vincent and the Grenadines',
    iso2: 'vc',
    dialCode: '1',
    priority: 20,
    areaCodes: ['784'],
  },
  ws: {
    key: 'ws',
    name: 'Samoa',
    iso2: 'ws',
    dialCode: '685',
    priority: 1,
    areaCodes: null,
  },
  sm: {
    key: 'sm',
    name: 'San Marino',
    iso2: 'sm',
    dialCode: '378',
    priority: 1,
    areaCodes: null,
  },
  st: {
    key: 'st',
    name: 'São Tomé and Príncipe (São Tomé e Príncipe)',
    iso2: 'st',
    dialCode: '239',
    priority: 1,
    areaCodes: null,
  },
  sa: {
    key: 'sa',
    name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
    iso2: 'sa',
    dialCode: '966',
    priority: 1,
    areaCodes: null,
  },
  sn: {
    key: 'sn',
    name: 'Senegal (Sénégal)',
    iso2: 'sn',
    dialCode: '221',
    priority: 1,
    areaCodes: null,
  },
  rs: {
    key: 'rs',
    name: 'Serbia (Србија)',
    iso2: 'rs',
    dialCode: '381',
    priority: 1,
    areaCodes: null,
  },
  sc: {
    key: 'sc',
    name: 'Seychelles',
    iso2: 'sc',
    dialCode: '248',
    priority: 1,
    areaCodes: null,
  },
  sl: {
    key: 'sl',
    name: 'Sierra Leone',
    iso2: 'sl',
    dialCode: '232',
    priority: 1,
    areaCodes: null,
  },
  sg: {
    key: 'sg',
    name: 'Singapore',
    iso2: 'sg',
    dialCode: '65',
    priority: 1,
    areaCodes: null,
  },
  sx: {
    key: 'sx',
    name: 'Sint Maarten',
    iso2: 'sx',
    dialCode: '1',
    priority: 21,
    areaCodes: ['721'],
  },
  sk: {
    key: 'sk',
    name: 'Slovakia (Slovensko)',
    iso2: 'sk',
    dialCode: '421',
    priority: 1,
    areaCodes: null,
  },
  si: {
    key: 'si',
    name: 'Slovenia (Slovenija)',
    iso2: 'si',
    dialCode: '386',
    priority: 1,
    areaCodes: null,
  },
  sb: {
    key: 'sb',
    name: 'Solomon Islands',
    iso2: 'sb',
    dialCode: '677',
    priority: 1,
    areaCodes: null,
  },
  so: {
    key: 'so',
    name: 'Somalia (Soomaaliya)',
    iso2: 'so',
    dialCode: '252',
    priority: 1,
    areaCodes: null,
  },
  za: {
    key: 'za',
    name: 'South Africa',
    iso2: 'za',
    dialCode: '27',
    priority: 1,
    areaCodes: null,
  },
  kr: {
    key: 'kr',
    name: 'South Korea (대한민국)',
    iso2: 'kr',
    dialCode: '82',
    priority: 1,
    areaCodes: null,
  },
  ss: {
    key: 'ss',
    name: 'South Sudan (‫جنوب السودان‬‎)',
    iso2: 'ss',
    dialCode: '211',
    priority: 1,
    areaCodes: null,
  },
  es: {
    key: 'es',
    name: 'Spain (España)',
    iso2: 'es',
    dialCode: '34',
    priority: 1,
    areaCodes: null,
  },
  lk: {
    key: 'lk',
    name: 'Sri Lanka (ශ්‍රී ලංකාව)',
    iso2: 'lk',
    dialCode: '94',
    priority: 1,
    areaCodes: null,
  },
  sd: {
    key: 'sd',
    name: 'Sudan (‫السودان‬‎)',
    iso2: 'sd',
    dialCode: '249',
    priority: 1,
    areaCodes: null,
  },
  sr: {
    key: 'sr',
    name: 'Suriname',
    iso2: 'sr',
    dialCode: '597',
    priority: 1,
    areaCodes: null,
  },
  sj: {
    key: 'sj',
    name: 'Svalbard and Jan Mayen',
    iso2: 'sj',
    dialCode: '47',
    priority: 1,
    areaCodes: ['79'],
  },
  se: {
    key: 'se',
    name: 'Sweden (Sverige)',
    iso2: 'se',
    dialCode: '46',
    priority: 1,
    areaCodes: null,
  },
  ch: {
    key: 'ch',
    name: 'Switzerland (Schweiz)',
    iso2: 'ch',
    dialCode: '41',
    priority: 1,
    areaCodes: null,
  },
  sy: {
    key: 'sy',
    name: 'Syria (‫سوريا‬‎)',
    iso2: 'sy',
    dialCode: '963',
    priority: 1,
    areaCodes: null,
  },
  tw: {
    key: 'tw',
    name: 'Taiwan (台灣)',
    iso2: 'tw',
    dialCode: '886',
    priority: 1,
    areaCodes: null,
  },
  tj: {
    key: 'tj',
    name: 'Tajikistan',
    iso2: 'tj',
    dialCode: '992',
    priority: 1,
    areaCodes: null,
  },
  tz: {
    key: 'tz',
    name: 'Tanzania',
    iso2: 'tz',
    dialCode: '255',
    priority: 1,
    areaCodes: null,
  },
  th: {
    key: 'th',
    name: 'Thailand (ไทย)',
    iso2: 'th',
    dialCode: '66',
    priority: 1,
    areaCodes: null,
  },
  tl: {
    key: 'tl',
    name: 'Timor-Leste',
    iso2: 'tl',
    dialCode: '670',
    priority: 1,
    areaCodes: null,
  },
  tg: {
    key: 'tg',
    name: 'Togo',
    iso2: 'tg',
    dialCode: '228',
    priority: 1,
    areaCodes: null,
  },
  tk: {
    key: 'tk',
    name: 'Tokelau',
    iso2: 'tk',
    dialCode: '690',
    priority: 1,
    areaCodes: null,
  },
  to: {
    key: 'to',
    name: 'Tonga',
    iso2: 'to',
    dialCode: '676',
    priority: 1,
    areaCodes: null,
  },
  tt: {
    key: 'tt',
    name: 'Trinidad and Tobago',
    iso2: 'tt',
    dialCode: '1',
    priority: 22,
    areaCodes: ['868'],
  },
  tn: {
    key: 'tn',
    name: 'Tunisia (‫تونس‬‎)',
    iso2: 'tn',
    dialCode: '216',
    priority: 1,
    areaCodes: null,
  },
  tr: {
    key: 'tr',
    name: 'Turkey (Türkiye)',
    iso2: 'tr',
    dialCode: '90',
    priority: 1,
    areaCodes: null,
  },
  tm: {
    key: 'tm',
    name: 'Turkmenistan',
    iso2: 'tm',
    dialCode: '993',
    priority: 1,
    areaCodes: null,
  },
  tc: {
    key: 'tc',
    name: 'Turks and Caicos Islands',
    iso2: 'tc',
    dialCode: '1',
    priority: 23,
    areaCodes: ['649'],
  },
  tv: {
    key: 'tv',
    name: 'Tuvalu',
    iso2: 'tv',
    dialCode: '688',
    priority: 1,
    areaCodes: null,
  },
  vi: {
    key: 'vi',
    name: 'U.S. Virgin Islands',
    iso2: 'vi',
    dialCode: '1',
    priority: 24,
    areaCodes: ['340'],
  },
  ug: {
    key: 'ug',
    name: 'Uganda',
    iso2: 'ug',
    dialCode: '256',
    priority: 1,
    areaCodes: null,
  },
  ua: {
    key: 'ua',
    name: 'Ukraine (Україна)',
    iso2: 'ua',
    dialCode: '380',
    priority: 1,
    areaCodes: null,
  },
  ae: {
    key: 'ae',
    name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
    iso2: 'ae',
    dialCode: '971',
    priority: 1,
    areaCodes: null,
  },
  gb: {
    key: 'gb',
    name: 'United Kingdom',
    iso2: 'gb',
    dialCode: '44',
    priority: 1,
    areaCodes: null,
  },
  us: {
    key: 'us',
    name: 'United States',
    iso2: 'us',
    dialCode: '1',
    priority: 0,
    areaCodes: null,
  },
  uy: {
    key: 'uy',
    name: 'Uruguay',
    iso2: 'uy',
    dialCode: '598',
    priority: 1,
    areaCodes: null,
  },
  uz: {
    key: 'uz',
    name: 'Uzbekistan (Oʻzbekiston)',
    iso2: 'uz',
    dialCode: '998',
    priority: 1,
    areaCodes: null,
  },
  vu: {
    key: 'vu',
    name: 'Vanuatu',
    iso2: 'vu',
    dialCode: '678',
    priority: 1,
    areaCodes: null,
  },
  va: {
    key: 'va',
    name: 'Vatican City (Città del Vaticano)',
    iso2: 'va',
    dialCode: '39',
    priority: 1,
    areaCodes: ['06698'],
  },
  ve: {
    key: 've',
    name: 'Venezuela',
    iso2: 've',
    dialCode: '58',
    priority: 1,
    areaCodes: null,
  },
  vn: {
    key: 'vn',
    name: 'Vietnam (Việt Nam)',
    iso2: 'vn',
    dialCode: '84',
    priority: 1,
    areaCodes: null,
  },
  wf: {
    key: 'wf',
    name: 'Wallis and Futuna (Wallis-et-Futuna)',
    iso2: 'wf',
    dialCode: '681',
    priority: 1,
    areaCodes: null,
  },
  eh: {
    key: 'eh',
    name: 'Western Sahara (‫الصحراء الغربية‬‎)',
    iso2: 'eh',
    dialCode: '212',
    priority: 1,
    areaCodes: ['5288', '5289'],
  },
  ye: {
    key: 'ye',
    name: 'Yemen (‫اليمن‬‎)',
    iso2: 'ye',
    dialCode: '967',
    priority: 1,
    areaCodes: null,
  },
  zm: {
    key: 'zm',
    name: 'Zambia',
    iso2: 'zm',
    dialCode: '260',
    priority: 1,
    areaCodes: null,
  },
  zw: {
    key: 'zw',
    name: 'Zimbabwe',
    iso2: 'zw',
    dialCode: '263',
    priority: 1,
    areaCodes: null,
  },
  ax: {
    key: 'ax',
    name: 'Åland Islands',
    iso2: 'ax',
    dialCode: '358',
    priority: 1,
    areaCodes: ['18'],
  },
} as const;

export default phoneCountries;
